// Rascunho de Malha (`/rascunhoMalhaAereo`): a malha montada só neste navegador, sem ir ao sistema.
//
// Banco IndexedDB próprio, como os rascunhos do RSVP e do orçamento (`rascunhoRsvp`, `rascunhoOrcamento`): um
// registro por usuário, com as opções e os grupos da tela como estão. Tudo best-effort: sem IndexedDB a tela abre
// vazia, e o Salvar avisa que não guardou.

const DB_NAME = 'accessRascunhosMalha';
const DB_VERSION = 1;
const STORE = 'malha';

const chave = () => localStorage.getItem('idUsuario') || 'anon';

function abrirDb() {
    return new Promise((resolve, reject) => {
        if (typeof window === 'undefined' || !window.indexedDB) {
            reject(new Error('IndexedDB indisponível'));
            return;
        }
        const req = window.indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = () => {
            if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE);
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
}

// Um pedido ao store numa transação; devolve o resultado dele.
async function noStore(modo, pedido) {
    const db = await abrirDb();
    try {
        return await new Promise((resolve, reject) => {
            const tx = db.transaction(STORE, modo);
            const req = pedido(tx.objectStore(STORE));
            tx.oncomplete = () => resolve(req.result);
            tx.onerror = () => reject(tx.error);
            tx.onabort = () => reject(tx.error);
        });
    } finally {
        db.close();
    }
}

/** A tela do último Salvar deste usuário, { opcoes, trechos }, ou null. */
export const lerRascunhoMalha = () => noStore('readonly', (os) => os.get(chave())).then((r) => r ?? null, () => null);

/** Guarda a tela, { opcoes, trechos }. Devolve false quando o navegador não deixou. */
export const salvarRascunhoMalha = (tela) => noStore('readwrite', (os) => os.put(tela, chave())).then(() => true, () => false);
